import React, { useState } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import Hotkeys from 'react-hot-keys'

import styles, { colors } from '../styles/global'
import FollowSwitchableTag from './FollowSwitchableTag/FollowSwitchableTag'
import UpdatesMoreButton from '../UIComponents/FloatModals/MorePopupsOfMainViews/Updates/UpdatesMoreButton'
import { translate } from '../../i18n/TranslationService'
import ChangeObjectListModal from '../UIComponents/FloatModals/ChangeObjectListModal'
import Shortcut from '../UIControls/Shortcut'
import { useSelector } from 'react-redux'
import AppPopover from '../UIComponents/ModalShell/AppPopover'
import { checkIfSelectedAllProjects } from '../SettingsView/ProjectsSettings/ProjectHelper'

export default function HeaderGlobalProject({
    smallScreenNavigation,
    setAmountFollowedFeeds,
    setAmountAllFeeds,
    amountFollowedFeeds,
    amountAllFeeds,
    projectId,
    selectedUser,
}) {
    const mobile = useSelector(state => state.smallScreenNavigation)
    const selectedProjectIndex = useSelector(state => state.selectedProjectIndex)
    const project = useSelector(state => state.loggedUserProjects[selectedProjectIndex])
    const realProjectIds = useSelector(state => state.loggedUser.realProjectIds)
    const isAnonymous = useSelector(state => state.loggedUser.isAnonymous)
    const blockShortcuts = useSelector(state => state.blockShortcuts)
    const showShortcuts = useSelector(state => state.showShortcuts)
    const showFloatPopup = useSelector(state => state.showFloatPopup)
    const [open, setOpen] = useState(false)

    const inAllProjects = checkIfSelectedAllProjects(selectedProjectIndex)
    const accessGranted = !isAnonymous && (inAllProjects || (project && realProjectIds.includes(project.id)))

    return (
        <View style={localStyles.container}>
            <Hotkeys
                disabled={blockShortcuts || !showShortcuts || showFloatPopup !== 0 || !accessGranted}
                keyName={'s,alt+s'}
                onKeyDown={() => setOpen(true)}
                filter={e => true}
            />
            <AppPopover
                content={<ChangeObjectListModal closePopover={() => setOpen(false)} />}
                onClickOutside={() => setOpen(false)}
                isOpen={open}
                position={['bottom', 'left', 'right', 'top']}
                padding={4}
                align={'start'}
                contentLocation={mobile ? null : undefined}
            >
                <TouchableOpacity disabled={!accessGranted} accessible={false} onPress={() => setOpen(true)}>
                    <Text style={localStyles.title}>{translate('Updates')}</Text>
                </TouchableOpacity>
            </AppPopover>
            {showShortcuts && showFloatPopup === 0 && accessGranted && !mobile && (
                <Shortcut text={'S'} containerStyle={localStyles.shortcut} />
            )}

            <UpdatesMoreButton projectId={projectId} user={selectedUser} />
            <View style={localStyles.followTag}>
                <FollowSwitchableTag
                    smallScreenNavigation={smallScreenNavigation}
                    setAmountFollowedFeeds={setAmountFollowedFeeds}
                    setAmountAllFeeds={setAmountAllFeeds}
                    amountFollowedFeeds={amountFollowedFeeds}
                    amountAllFeeds={amountAllFeeds}
                />
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 80,
        minHeight: 80,
        maxHeight: 80,
        paddingTop: 40,
        paddingBottom: 8,
    },
    title: {
        ...styles.title5,
        color: colors.Text01,
    },
    followTag: {
        flex: 1,
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    shortcut: {
        marginLeft: 8,
    },
})
